import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class TicketsService {
  private url: string;
  private url2: string;
  private token: string | null;
  private headers: HttpHeaders;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = `${GLOBAL.url}/ticket/`;
    this.url2 = `${GLOBAL.url}/ticketindex/`;
 
    this.token = JSON.parse(localStorage.getItem('token'));
    //this.token = this.token === 'undefined' ? null : this.token;
    this.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
  }

  create(json: any): Observable<any> {
    return this.petition(this.url + 'new', json);
  }

  getOne(id: any): Observable<any> {
    return this.petition(`${this.url}detail/${id}`);
  }

  checkItems(json: any): Observable<any> {
    return this.petition(`${this.url}preticket`, json);
  }

  indexesdetail(id: any): Observable<any> {
    return this.petition(`${this.url}indexesdetail/${id}`);
  }

  indexesmanifestdetail(id: any): Observable<any> {
    return this.petition(`${this.url}indexesmanifestdetail/${id}`);
  }

  indexesscrap(id: any): Observable<any> {
    return this.petition(`${this.url}indexesscrapdetail/${id}`);
  }

  bulkstatus(json: any): Observable<any> {
    return this.petition(`${this.url2}bulkstatus`, json);
  }

  procesarBulk(json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/processbulk`, json);
  }

  procesarycrearBulk(json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/processandcreatebulk`, json);
  }

  bulkReceived(json: any): Observable<any> {
    return this.petition(`${this.url2}bulkreceive`, json);
  }

  bulkLocations(json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/changebulklocation`, json);
  }

  getPOs(): Observable<any> {
    return this.petition(`${GLOBAL.url}/po/listwithpi`);
  }

  getPOsNotInvoiced(): Observable<any> {
    return this.petition(`${GLOBAL.url}/po/notinvoiced`);
  }

  removeItemContainer(id: any, json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/removeitemcontainer/${id}`, json);
  }

  removeBulkItemContainer(id: any, json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/removebulkitemcontainer/${id}`, json);
  }

  dropContainer(id: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/dropcontainer/${id}`);
  }

  changeContainer(json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/changecontainer`, json);
  }

  removeItemBatch(id: any, json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/removeitembatch/${id}`, json);
  }

  removeBulkItemBatch(id: any, json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/removebulkitembatch/${id}`, json);
  }

  dropBatch(id: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/dropbatch/${id}`);
  }


  getAll(type: any = 'ALL', page: any, perPage: any, search: any, sort: any = '', sortby: any = ''): Observable<any> {
    let url = `${this.url}listbyall/${type}?page=${page}&perpage=${perPage}`;
    
    if (sortby !== '') {
      if (sort === '') {
        sort = 'DESC';
      }
      url += `&order=${sort}&orderby=${sortby}`;
    }

    return this.petition(url, search);
  }

  edit(id: any, json: any): Observable<any> {
    return this.petition(`${this.url}edit/${id}`, json);
  }

  editWeight(json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/editweight`, json);
  }

  editComments(id: any, json: any): Observable<any> {
    return this.petition(`${this.url2}editcomment/${id}`, json);
  }

  delete(id: any): Observable<any> {
    return this.petition(`${this.url}remove/${id}`);
  }

  getSearch(page: any, perPage: any, search: any): Observable<any> {
    return this.petition(`${this.url}search?page=${page}&perpage=${perPage}`, search);
  }

  getByPO(po_id: any): Observable<any> {
    return this.petition(`${this.url}listbypo/${po_id}`);
  }

  createWeight(json: any, bulk_cant: any = 0): Observable<any> {
    if (bulk_cant > 1) {
      json.bulk_cant = bulk_cant;
      return this.petition(`${GLOBAL.url}/weightitem/newbulk`, json);
    }
    return this.petition(`${GLOBAL.url}/weightitem/new`, json);
  }

  createVirtual(json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/newvirtual`, json);
  }

  editVirtual(id: any, json: any): Observable<any> {
    return this.petition(`${GLOBAL.url}/weightitem/editvirtual/${id}`, json);
  }

  petition(url: any, json: any = null, type: any | null = null): Observable<any> {

    this.token = JSON.parse(localStorage.getItem('token'));
  

    let params = `authorization=${this.token}`;

    if (json !== null) {
      const jsonStr = encodeURIComponent(JSON.stringify(json));
      params += `&json=${jsonStr}`;
    }

    if (type !== null) {
      params += `&type=${type}`;
    }

   

    return this._http.post(url, params, { headers: this.headers }).pipe(
      map((res: any) => res)
    );
  }
}
